module.exports = __webpack_public_path__ + "x4.no1.7ae1a5dc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/x4.no1.jpg
// module id = oTnR
// module chunks = 0